import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiPageTemplate,
} from "@inscopix/ideas-eui";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { memo, useMemo } from "react";
import { useSetAppHeader } from "providers/AppHeaderProvider";
import { ToolBreadcrumbs } from "components/HeaderBreadcrumbs/ToolBreadCrumbs";
import { useToolDataContext } from "./ToolDataProvider";
import { ToolTabTool } from "components/ToolProjectTabs/ToolTabTool";

/*
 * View-only tool home page with tab layout
 * Only one tab for now but will expand in the future
 */
export const ToolTabsViewOnly = memo(function ToolTabsViewOnly() {
  const { tool } = useToolDataContext();
  const currentTenant = useTenantContext((s) => s.currentTenant);
  // set header
  const breadcrumbs = useMemo(() => {
    return (
      <ToolBreadcrumbs
        key={"breadcrumbs"}
        tool={tool}
        currentTenant={currentTenant}
        inDraftMode={false}
      />
    );
  }, [tool, currentTenant]);
  useSetAppHeader({ header: breadcrumbs });
  return (
    <EuiPageTemplate responsive={[]}>
      <EuiPageTemplate.Header
        pageTitle={
          <EuiFlexGroup gutterSize={"s"} alignItems="center" responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiText>
                <h2>{tool.name}</h2>
              </EuiText>
            </EuiFlexItem>
          </EuiFlexGroup>
        }
      />

      <EuiPageTemplate.Section contentProps={{ style: { flexGrow: 1 } }}>
        <ToolTabTool />
      </EuiPageTemplate.Section>
    </EuiPageTemplate>
  );
});
